import { render, staticRenderFns } from "./tradelistomni.vue?vue&type=template&id=c7f5a11a&scoped=true"
import script from "./tradelistomni.vue?vue&type=script&lang=js"
export * from "./tradelistomni.vue?vue&type=script&lang=js"
import style0 from "./tradelistomni.vue?vue&type=style&index=0&id=c7f5a11a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f5a11a",
  null
  
)

export default component.exports